import { useIsWorkflowsEnabled } from "@circle-react-shared/Workflows/hooks/useIsWorkflowsEnabled";
import { useCanSwitchCommunities } from "@circle-react/hooks/community_switcher/useCanSwitchCommunities";
import { isEmpty } from "lodash";

import { useMobileCommunitySwitcherModal } from "@/react/components/Modals/MobileCommunitySwitcherModal";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useMediaQuery } from "@/react/hooks/useMediaQuery";
import { useBackendProps } from "@/react/providers/AppContext";

import { LogoLink } from "../LogoLink";
import type { LogoTopSectionViewProps } from "../LogoTopSectionView";
import { useLogoMenuOptions } from "./hooks/useLogoMenuOptions";
import { LogoMenu } from "./LogoMenu";

export const LogoTopSectionV4View = ({
  communityName = "",
  isAdmin = false,
  isModerator = false,
  logoType = "icon",
  logoUrl,
  onLogoClick,
  showCustomizeTheme = false,
  memberCount,
  moderationCount,
}: LogoTopSectionViewProps) => {
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const mobileCommunitySwitcherModal = useMobileCommunitySwitcherModal();
  const { currentCommunityMember } = usePunditUserContext();

  const { display_community_switcher: hasCommunitySwitcher } =
    useBackendProps();
  const canSwitchCommunities = useCanSwitchCommunities();

  const isWorkflowsEnabled = useIsWorkflowsEnabled();

  const menuOptions = useLogoMenuOptions({
    isAdmin,
    isModerator,
    memberCount,
    moderationCount,
    showCustomizeTheme,
    isWorkflowsEnabled,
  });

  const shouldDisplayMobileCommunitySwitcher =
    isMobile && hasCommunitySwitcher && canSwitchCommunities;

  if (shouldDisplayMobileCommunitySwitcher) {
    return (
      <div
        className="flex w-full items-center"
        id="community-logo-mobile-community-switcher"
      >
        <LogoLink
          communityName={communityName}
          logoType={logoType}
          logoUrl={logoUrl}
          onLogoClick={() => {
            void mobileCommunitySwitcherModal.show();
          }}
        />
        <LogoMenu menuOptions={menuOptions} />
      </div>
    );
  }

  if (isEmpty(menuOptions)) {
    return (
      <div id="community-logo-no-dropdown">
        <LogoLink
          communityName={communityName}
          logoType={logoType}
          logoUrl={logoUrl}
          onLogoClick={currentCommunityMember ? onLogoClick : undefined} // For logged out users, the logo is not clickable.
          as={currentCommunityMember ? "button" : "div"}
        />
      </div>
    );
  }

  return (
    <LogoMenu menuOptions={menuOptions}>
      <LogoLink
        communityName={communityName}
        logoType={logoType}
        logoUrl={logoUrl}
        as="div"
      />
    </LogoMenu>
  );
};
